import config from "../../utils/config";
import {
  Typography,
  TextField,
  Button,
  FormControl,
  MenuItem,
  InputLabel,
  Select,
  Box,
  Link,
  Container,
  Card,
  CardContent,
  Stepper,
  Step,
  StepLabel,
  Grid,
  Alert,
} from "@mui/material";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import ArrowLeftIcon from "@mui/icons-material/ArrowLeft";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { toast } from "react-toastify";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import PhoneInput from "react-phone-input-2";
import moment from "moment";
import { loadStripe } from "@stripe/stripe-js";
import countries from "../../utils/countries";
import { useEffect, useState } from "react";
import axios from "axios";
import { useDebouncedCallback } from "use-debounce";
import { DateTimePicker } from "@mui/x-date-pickers";
import { validateEmail } from "../../utils/email-validator";

const steps = ["Verification", "Personal Info", "Event Options", "Confirmation"];

function BuyEvent(props) {
  const [panel, setPanel] = useState(0);
  const [esnCard, setEsnCard] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [birthdate, setBirthdate] = useState(null);
  const [country, setCountry] = useState("");
  const [passport, setPassport] = useState("");
  const [phone, setPhone] = useState("");
  const [options, setOptions] = useState({});
  const [withDiscount, setWithDiscount] = useState(false);
  const [vat, setVat] = useState("");
  const [showVat, setShowVat] = useState(false);
  const [event, setEvent] = useState(null);
  const [submissionType, setSubmissionType] = useState("online");
  let messagesEnd = null;

  useEffect(() => {
    fetchOrganization();
    loadDefaultOptions();
  }, []); //eslint-disable-line

  useEffect(() => {
    setEvent(props.event);
    setWithDiscount(false);
  }, [props.organization]); //eslint-disable-line

  useEffect(() => {
    if (panel !== 0) {
      scrollToBottom();
    }
  }, [panel]); //eslint-disable-line

  const loadDefaultOptions = () => {
    let result = {};

    for (let option of props.event.options) {
      if (option.type === "select-multi") {
        result[option.name] = [];
      } else {
        result[option.name] = "";
      }
    }

    setOptions(result);
  };

  const scrollToBottom = () => {
    messagesEnd?.scrollIntoView({ behavior: "smooth" });
  };

  const fetchOrganization = () => {
    axios
      .get(`${config.API_ENDPOINT}/organizations/${props.event.organization}`)
      .then((res) => {
        let organization = res.data;
        setShowVat(organization.showVAT);
      })
      .catch(() => {
        toast.error("An unexpected error has occurred");
      });
  };

  const fetchStudent = () => {
    axios
      .get(`${config.API_ENDPOINT}/students/esncard/${esnCard}`)
      .then((res) => {
        let student = res.data;

        if (moment(student.registerDate).add(1, "year").isBefore(moment())) {
          toast.error("Invalid ESNcard. (Expired)");
        } else {
          if (moment().subtract(24, "h").isBefore(moment(student.registerDate))) {
            setWithDiscount(true);
            props.showSpecial();
          }

          setName(student.name);
          setEmail(student.email);
          setBirthdate(moment.utc(student.birthdate));
          setCountry(student.country);
          setPassport(student.passport);
          setPhone(student.phone);
          setVat("");
          setPanel(1);
        }
      })
      .catch((err) => {
        if (err.response?.status === 404) {
          toast.warning("Invalid ESN card");
        } else {
          toast.error("An unexpected error has occurred");
        }
      });
  };

  const submitForWishlist = useDebouncedCallback(
    () => {
      axios
        .post(`${config.API_ENDPOINT}/events/${props.event._id}/wishlist`, {
          name,
          email,
          phone,
          birthdate: birthdate.valueOf(),
          country,
          passport,
          esnCard: esnCard !== "" ? esnCard : null,
          options: JSON.stringify(options),
          event: props.event._id,
          organization: props.event.organization,
          vat,
          shared: props.shared ? true : false,
          endpoint: config.WEB_ENDPOINT,
        })
        .then(() => {
          setSubmissionType("wishlist");
          setPanel(3);
        })
        .catch((err) => {
          switch (err.response?.status) {
            case 409:
              toast.warning("You've already wishlisted for this event");
              break;
            case 406:
              toast.warning("Your ESNcard does not belong to this event's organization.");
              break;
            default:
              toast.error("An unexpected error has occurred");
              break;
          }
        });
    },
    500,
    { leading: true }
  );

  const submitForPay = useDebouncedCallback(
    () => {
      let purchase = {
        name,
        email,
        phone,
        birthdate: birthdate.valueOf(),
        country,
        passport,
        esnCard,
        options: JSON.stringify(options),
        event: props.event._id,
        organization: props.event.organization,
        vat: vat,
      };

      let url = `${config.API_ENDPOINT}/checkout/event`;

      if (props.shared) {
        url = `${config.API_ENDPOINT}/checkout/shared-event`;
      }

      axios
        .post(url, {
          organization: purchase.organization,
          cancel: `${config.WEB_ENDPOINT}/iframes/event-details/${purchase.organization}/${purchase.event}`,
          success: `${config.WEB_ENDPOINT}/iframes/purchase/event/${purchase.organization}`,
          metadata: {
            type: "event",
            data: purchase,
          },
        })
        .then(async (res) => {
          const result = res.data;

          if (result.paid) {
            setSubmissionType("online");
            setPanel(3);
            return;
          }

          switch (result.type) {
            case "stripe":
              const stripe = await loadStripe(result.publicKey);

              const redirect = await stripe.redirectToCheckout({
                sessionId: result.session,
              });

              if (redirect.error) {
                toast.error("Error opening the checkout");
                console.error(redirect.error);
              }
              break;
            case "redsys":
              // Create a hidden form element programatically and submit it
              const form = document.createElement("form");
              form.method = "POST";
              form.action = result.url;
              form.style = "display: none";

              for (let key in result.body) {
                const input = document.createElement("input");
                input.type = "hidden";
                input.name = key;
                input.value = result.body[key];
                form.appendChild(input);
              }

              document.body.appendChild(form);
              form.submit();
              break;
            default:
              toast.error("An unexpected error has occurred");
              break;
          }
        })
        .catch((err) => {
          switch (err.response?.status) {
            case 400:
              toast.warning("Invalid request. Please verify your data.");
              break;
            case 409:
              toast.warning("You've already bought this event");
              break;
            case 401:
              toast.warning("This organization does not support online payments");
              break;
            case 403:
              toast.warning("This event has sold out");
              break;
            case 406:
              toast.warning("Your ESNcard does not belong to this event's organization.");
              break;
            default:
              toast.error("An unexpected error has occurred");
              break;
          }
        });
    },
    500,
    { leading: true }
  );

  const submit = useDebouncedCallback(
    () => {
      axios
        .post(`${config.API_ENDPOINT}/events/${props.event._id}/purchase`, {
          name,
          email,
          phone,
          birthdate: birthdate.valueOf(),
          country,
          passport,
          esnCard: esnCard !== "" ? esnCard : null,
          options: JSON.stringify(options),
          event: props.event._id,
          organization: props.event.organization,
          vat,
          shared: props.shared ? true : false,
          endpoint: config.WEB_ENDPOINT,
        })
        .then((res) => {
          setSubmissionType("office");
          setPanel(3);
        })
        .catch((err) => {
          switch (err.response?.status) {
            case 409:
              toast.warning("You've already bought this event");
              break;
            case 403:
              toast.warning("This event has sold out");
              break;
            case 406:
              toast.warning("Your ESNcard does not match this event's organization.");
              break;
            default:
              toast.error("An unexpected error has occurred");
              break;
          }
        });
    },
    500,
    { leading: true }
  );

  const optionsFilled = () => {
    for (let option of event.options) {
      if (!option.required) continue;

      if (
        options[option.name] == null ||
        options[option.name] === "" ||
        (Array.isArray(options[option.name]) && options[option.name].length === 0)
      ) {
        return false;
      }
    }

    return true;
  };

  const calculatePrice = () => {
    let price = props.event.regularPrice;

    if (!props.event.esnCardRequired && esnCard !== "" && props.event.esnCardPrice != null) {
      price = props.event.esnCardPrice;
    }

    if (
      withDiscount &&
      props.event.esnCardBuyPrice != null &&
      props.event.esnCardBuyPrice < props.event.regularPrice
    ) {
      price = props.event.esnCardBuyPrice;
    }

    return price;
  };

  const getPanel = () => {
    switch (panel) {
      case 0:
        return (
          <Box sx={{ py: 3 }}>
            <Typography variant="h6" sx={{ fontWeight: 700, mb: 2 }}>
              Enter Your ESNcard
            </Typography>
            <Typography variant="body2" sx={{ color: "text.secondary", mb: 2 }}>
              Please provide your ESNcard number to check for discounts and exclusive prices.
            </Typography>
            <TextField
              variant="outlined"
              fullWidth
              label="ESNcard Number"
              name="esnCard"
              type="text"
              autoComplete="off"
              value={esnCard}
              onChange={(e) => setEsnCard(e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, ''))}
              placeholder="e.g., 000ABC1"
              sx={{ mb: 2, input: { textTransform: 'uppercase' } }}
            />
            {!props.event.esnCardRequired || esnCard !== "" ? (
              <Box sx={{ display: "flex", gap: 1 }}>
                <Button
                  variant="contained"
                  sx={{
                    backgroundColor: "#00aeef",
                    color: "white",
                    textTransform: "none",
                    fontWeight: 600,
                    flex: 1,
                    "&:hover": { backgroundColor: "#0095d1" },
                  }}
                  endIcon={<ArrowRightIcon />}
                  onClick={() => {
                    if (esnCard !== "") {
                      fetchStudent();
                    } else {
                      setPanel(1);
                    }
                  }}
                >
                  {esnCard !== "" ? "Verify Card" : "Continue Without Card"}
                </Button>
              </Box>
            ) : null}
          </Box>
        );
      case 1:
        return (
          <Box sx={{ py: 3 }}>
            <Typography variant="h6" sx={{ fontWeight: 700, mb: 2 }}>
              Personal Information
            </Typography>
            <Typography variant="body2" sx={{ color: "text.secondary", mb: 3 }}>
              Please provide your personal details to complete the registration.
            </Typography>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextField
                  variant="outlined"
                  required
                  fullWidth
                  label="Full Name"
                  name="name"
                  type="text"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  disabled={esnCard !== ""}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  variant="outlined"
                  required
                  fullWidth
                  label="Email Address"
                  name="email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value.trim())}
                  disabled={esnCard !== ""}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <DatePicker
                  label="Date of Birth"
                  format="DD/MM/YYYY"
                  timezone="UTC"
                  value={birthdate}
                  onChange={(date) => setBirthdate(date)}
                  slotProps={{ textField: { required: true, fullWidth: true } }}
                  disabled={esnCard !== ""}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  variant="outlined"
                  required
                  fullWidth
                  label="ID/Passport Number"
                  name="passport"
                  type="text"
                  value={passport}
                  onChange={(e) => setPassport(e.target.value.trim())}
                  disabled={esnCard !== ""}
                />
              </Grid>
              <Grid item xs={12}>
                <FormControl
                  fullWidth
                  variant="outlined"
                  required
                  disabled={esnCard !== ""}
                >
                  <InputLabel sx={{ backgroundColor: "#fff" }}>Country</InputLabel>
                  <Select value={country} onChange={(e) => setCountry(e.target.value)}>
                    {countries.map((country) => (
                      <MenuItem key={country.name} value={country.name}>
                        {country.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                <Box sx={{ mb: 2 }}>
                  <Typography variant="body2" sx={{ fontWeight: 600, mb: 1 }}>
                    Phone Number *
                  </Typography>
                  <PhoneInput
                    placeholder="Enter phone number"
                    value={phone}
                    onChange={(phone) => setPhone(`+${phone}`)}
                    disabled={esnCard !== ""}
                    containerStyle={{ width: "100%" }}
                  />
                </Box>
              </Grid>
              {showVat && (
                <Grid item xs={12}>
                  <TextField
                    variant="outlined"
                    fullWidth
                    label="VAT Number (Optional)"
                    name="vat"
                    type="text"
                    value={vat}
                    onChange={(e) => setVat(e.target.value.trim())}
                  />
                  <Typography variant="caption" sx={{ color: "text.secondary", display: "block", mt: 1 }}>
                    Only required if you need an invoice. Invalid VAT numbers will be ignored.
                  </Typography>
                </Grid>
              )}
            </Grid>

            <Box sx={{ display: "flex", gap: 1, mt: 3 }}>
              <Button
                variant="outlined"
                sx={{ textTransform: "none", fontWeight: 600 }}
                startIcon={<ArrowLeftIcon />}
                onClick={() => {
                  props.hideSpecial();
                  setWithDiscount(false);
                  setPanel(0);
                }}
              >
                Back
              </Button>
              {name !== "" &&
              email !== "" &&
              passport !== "" &&
              birthdate != null &&
              birthdate.isValid() &&
              country !== "" &&
              phone !== "" ? (
                <Button
                  variant="contained"
                  sx={{
                    backgroundColor: "#00aeef",
                    color: "white",
                    textTransform: "none",
                    fontWeight: 600,
                    flex: 1,
                    "&:hover": { backgroundColor: "#0095d1" },
                  }}
                  endIcon={<ArrowRightIcon />}
                  onClick={() => {
                    if (!validateEmail(email)) {
                      toast.error("Please enter a valid email address");
                      return;
                    }
                    setPanel(2);
                  }}
                >
                  Continue
                </Button>
              ) : null}
            </Box>
          </Box>
        );
      case 2:
        const filled = optionsFilled();
        return (
          <Box sx={{ py: 3 }}>
            <Typography variant="h6" sx={{ fontWeight: 700, mb: 2 }}>
              Event Options
            </Typography>
            <Typography variant="body2" sx={{ color: "text.secondary", mb: 3 }}>
              {props.event.options.length === 0
                ? "No additional options to select. You can proceed to complete your purchase."
                : "Please select any event options."}
            </Typography>

            {props.event.options.length > 0 && (
              <Grid container spacing={2} sx={{ mb: 3 }}>
                {props.event.options.map((option) => {
                  switch (option.type) {
                    case "select-multi":
                    case "select":
                      return (
                        <Grid item xs={12} key={option.name}>
                          <FormControl fullWidth variant="outlined" required={option.required}>
                            <InputLabel sx={{ backgroundColor: "#fff" }}>{option.name}</InputLabel>
                            <Select
                              value={options[option.name]}
                              multiple={option.type === "select-multi"}
                              onChange={(e) => {
                                let opt = { ...options };
                                opt[option.name] = e.target.value;
                                setOptions(opt);
                              }}
                            >
                              {option.values.map((value) => (
                                <MenuItem key={value} value={value}>
                                  {value}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </Grid>
                      );
                    case "text":
                      return (
                        <Grid item xs={12} key={option.name}>
                          <TextField
                            variant="outlined"
                            required={option.required}
                            fullWidth
                            label={option.name}
                            name={option.name}
                            type="text"
                            value={options[option.name]}
                            onChange={(e) => {
                              let opt = { ...options };
                              opt[option.name] = e.target.value;
                              setOptions(opt);
                            }}
                          />
                        </Grid>
                      );
                    case "datetime":
                      return (
                        <Grid item xs={12} key={option.name}>
                          <DateTimePicker
                            variant="outlined"
                            required={option.required}
                            label={option.name}
                            value={moment(options[option.name])}
                            onChange={(val) => {
                              let opt = { ...options };
                              opt[option.name] = moment(val).valueOf();
                              setOptions(opt);
                            }}
                            ampm={false}
                            slotProps={{ textField: { fullWidth: true } }}
                          />
                        </Grid>
                      );
                    default:
                      return null;
                  }
                })}
              </Grid>
            )}

            <Box sx={{ display: "flex", gap: 1 }}>
              <Button
                variant="outlined"
                sx={{ textTransform: "none", fontWeight: 600 }}
                startIcon={<ArrowLeftIcon />}
                onClick={() => {
                  loadDefaultOptions();
                  setPanel(1);
                }}
              >
                Back
              </Button>
              {filled && !props.wishlist && (
                <Box sx={{ display: "flex", gap: 1, flex: 1 }}>
                  {!props.event.onlineOnly && calculatePrice() > 0 ? (
                    <Button
                      variant="outlined"
                      sx={{ textTransform: "none", fontWeight: 600, flex: 1 }}
                      endIcon={<ArrowRightIcon />}
                      onClick={submit}
                    >
                      Pay in Office
                    </Button>
                  ) : null}

                  <Button
                    variant="contained"
                    sx={{
                      backgroundColor: "#00aeef",
                      color: "white",
                      textTransform: "none",
                      fontWeight: 600,
                      flex: 1,
                      "&:hover": { backgroundColor: "#0095d1" },
                    }}
                    endIcon={<ArrowRightIcon />}
                    onClick={submitForPay}
                  >
                    Pay Online
                  </Button>

                  {event.externalPayLink != null && event.externalPayLink !== "" && (
                    <Button
                      variant="outlined"
                      sx={{ textTransform: "none", fontWeight: 600, flex: 1 }}
                      endIcon={<ArrowRightIcon />}
                      onClick={submit}
                    >
                      {event.externalPayLabel != null && event.externalPayLabel !== ""
                        ? event.externalPayLabel
                        : "Pay Externally"}
                    </Button>
                  )}
                </Box>
              )}

              {filled && props.wishlist && (
                <Button
                  variant="contained"
                  sx={{
                    backgroundColor: "#3b2f74",
                    color: "white",
                    textTransform: "none",
                    fontWeight: 600,
                    flex: 1,
                    "&:hover": { backgroundColor: "#2e2561" },
                  }}
                  endIcon={<ArrowRightIcon />}
                  onClick={submitForWishlist}
                >
                  Add to Wishlist
                </Button>
              )}
            </Box>
          </Box>
        );
      case 3:
        const title = props.wishlist
          ? "Added to Wishlist!"
          : submissionType === "office"
            ? "Purchase Request Submitted"
            : "Purchase Confirmed!";
        const description = props.wishlist
          ? "Thank you. Your wishlist request was submitted successfully. Please check your email for updates."
          : submissionType === "office"
            ? "Thank you. Your purchase request was sent and is pending office payment/validation. Please check your email for next steps."
            : "Thank you for your registration. Your payment was successful. Please check your email for confirmation details.";

        return (
          <Box sx={{ py: 6, textAlign: "center" }}>
            <CheckCircleIcon sx={{ fontSize: 80, color: "#4caf50", mb: 2 }} />
            <Typography variant="h5" sx={{ fontWeight: 700, mb: 1 }}>
              {title}
            </Typography>
            <Typography variant="body1" sx={{ color: "text.secondary", mb: 2 }}>
              {description}
            </Typography>
            {event.externalPayLink != null && event.externalPayLink !== "" && (
              <Alert severity="info" sx={{ mt: 2 }}>
                You can also pay at{" "}
                <Link href={event.externalPayLink} target="_blank" rel="noreferrer" sx={{ fontWeight: 700 }}>
                  {event.externalPayLink}
                </Link>
              </Alert>
            )}
          </Box>
        );
      default:
        return null;
    }
  };

  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <Card sx={{ mb: 3 }}>
        <CardContent sx={{ p: 3 }}>
          <Stepper activeStep={panel} sx={{ mb: 2 }}>
            {steps.map((label, index) => (
              <Step key={label} completed={panel > index}>
                <StepLabel>{label}</StepLabel>
              </Step>
            ))}
          </Stepper>

          {/* Price Summary Card */}
          {panel !== 3 && (
            <Card sx={{ backgroundColor: "#f5f5f5", mb: 3 }}>
              <CardContent sx={{ p: 2 }}>
                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  <Box>
                    <Typography variant="body2" sx={{ color: "text.secondary" }}>
                      Total Price:
                    </Typography>
                    <Typography variant="h6" sx={{ fontWeight: 700, color: "#00aeef" }}>
                      {calculatePrice().toFixed(2)} €
                    </Typography>
                  </Box>
                  {withDiscount && (
                    <Alert severity="success" sx={{ mb: 0 }}>
                      ESNcard Discount Applied! 🎉
                    </Alert>
                  )}
                </Box>
              </CardContent>
            </Card>
          )}
        </CardContent>
      </Card>

      <Card>
        <CardContent sx={{ p: 3 }}>
          {getPanel()}
        </CardContent>
      </Card>

      <div
        style={{ float: "left", clear: "both" }}
        ref={(el) => {
          messagesEnd = el;
        }}
      ></div>
    </Container>
  );
}

export default BuyEvent;
